import { PRIORITY_COLORS } from "./constants";

export const getPriorityColor = (priority) => {
  const colors = {
    high: { main: "#EF4444", light: "#FEE2E2", text: "#991B1B" },
    medium: { main: "#F59E0B", light: "#FEF3C7", text: "#92400E" },
    low: { main: "#3B82F6", light: "#DBEAFE", text: "#1E3A8A" },
  };
  return colors[priority] || colors.low;
};

// The signed-in person's role, read from the login token the API issued.
// Team-member tokens carry userType "teamMember" + their role; workspace owners'
// tokens (OTP / Google / password login) don't, and the API treats them as the
// owner. localStorage "userRole" isn't reliable: the OTP login never sets it.
export const getSessionRole = () => {
  try {
    const token = localStorage.getItem("token");
    const payload = JSON.parse(atob(String(token).split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.userType === "teamMember" ? payload.role || "member" : "owner";
  } catch {
    return localStorage.getItem("userRole") || "owner";
  }
};

export const getUserInfo = () => {
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("username");
  const userRole = localStorage.getItem("userRole");
  return { userId, userName, userRole };
};

// Relative date presets are stored by name so a saved "Today" filter still
// means today after a reload on a later day.
const DATE_PRESET_DAYS_AGO = { today: 0, yesterday: 1 };

export const getDatePresetRange = (preset) => {
  const daysAgo = DATE_PRESET_DAYS_AGO[preset];
  if (daysAgo === undefined) return null;
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  const day = formatDateForInput(date);
  return { startDate: day, endDate: day };
};

export const formatDateForInput = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
